export default {
  logout: 'התנתקות',
  ensureLogout: 'האם אתה בטוח שברצונך להתנתק מהמערכת?',
};
